import cacheAdapter from './cacheAdapter';
import type { AxiosRequestConfig } from 'axios';

const config: AxiosRequestConfig = {
  timeout: 5 * 60 * 1000,
  baseURL: `${BUILD_VARS.QUERY_DOMAIN}/v1.0`,
  withCredentials: true,
  adapter: cacheAdapter,
};

if (process.env.basic_auth) {
  const authVal = process.env.basic_auth.replace(/\\/g, '');
  config.auth = JSON.parse(authVal);
}

export default config;
